<template>
  <div >
    <b-pagination size="md" :total-rows="100" v-model="currentPage" :per-page="10">
    </b-pagination>
    ToDO: make request with the next params:
    {{queryParams}}
  </div>
</template>

<script>
  export default {
    name: 'search-results',
    data () {
      return {
        // ToDO: replace with data from services
        currentPage: 2,
        queryParams: {}
      }
    },
    watch: {
      '$route.query': function (changedParams) {
        this.queryParams = changedParams
      }
    }
  }

</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// SearchResultsPage.vue?56045f25